import React, { Component } from 'react';
import './style.css';


class Home extends Component {
  constructor(props){
    super(props)
    this.state={

    };
  }

  render(){
  

    return (
    <div className = "homepage" >
    <div className = "homepage1">
<p><span className = "admin">ADMIN</span><span className = "gnn">GNN</span>OPINION</p>
        </div>
<div className = "adminimg">

<img src={require("./adminimage.jpg")}  className = "adminimage"/>
</div>
  <div className = "homepage2">
  <p>
  Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
  Lorem Ipsum has been the industry's standard dummy text ever since
   the 1500s, when an unknown printer took a galley of type and scrambled it
   to make a type specimen book. It has survived not only five centuries, but also the
   leap into electronic typesetting, remaining essentially unchanged. It was popularised in the
   1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently
   with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
  </p>
  
  </div>
        </div>
    );
  }
}
export default Home;



// WEBPACK FOOTER //
// ./src/pages/Home/index.js